var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSharpGreyFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.537,
    height: 17.678,
    viewBox: "0 0 18.537 17.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-sharp-svgrepo-com",
    d: "M11.456,4.2c.237-.683.356-1.024.532-1.119a.513.513,0,0,1,.487,0c.175.095.294.436.532,1.119l1.569,4.515a1.167,1.167,0,0,0,.162.364.512.512,0,0,0,.2.145,1.167,1.167,0,0,0,.4.042l4.779.1c.723.015,1.084.022,1.229.16a.513.513,0,0,1,.15.463c-.036.2-.324.415-.9.851l-3.809,2.888a1.171,1.171,0,0,0-.3.267.513.513,0,0,0-.076.235,1.169,1.169,0,0,0,.083.39l1.384,4.575c.209.692.314,1.038.228,1.218a.513.513,0,0,1-.394.286c-.2.027-.494-.18-1.088-.593L12.7,17.375a1.171,1.171,0,0,0-.345-.2.513.513,0,0,0-.247,0,1.171,1.171,0,0,0-.345.2l-3.923,2.73c-.593.413-.89.619-1.088.593a.513.513,0,0,1-.394-.286c-.086-.18.018-.526.228-1.218L7.97,14.62a1.168,1.168,0,0,0,.083-.39.513.513,0,0,0-.076-.235,1.17,1.17,0,0,0-.3-.267L3.871,10.841c-.576-.437-.864-.655-.9-.851a.513.513,0,0,1,.15-.463c.144-.138.506-.145,1.229-.16l4.779-.1a1.168,1.168,0,0,0,.4-.042.513.513,0,0,0,.2-.145,1.168,1.168,0,0,0,.162-.364Z",
    transform: "translate(-2.963 -3.023)",
    fill: "#a7a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharpGreyFilled);
export default __webpack_public_path__ + "static/media/star-sharp-grey-filled.1917bf187c2ba21d971bb2948f2a91ed.svg";
export { ForwardRef as ReactComponent };